export function accessories(accessoriesData) {
  return {
    type: 'ACCESSORIES',
    accessoriesData
  }
}